import React from 'react';
import {
  Switch,
  Route, 
  useLocation
} from "react-router-dom";
// Pages
import Home from '../pages/Home';
import Activities from '../pages/Activities';
import About from '../pages/About';
import Contact from '../pages/Contact';
import Public from '../pages/Public';
import Szechenyi from '../pages/Szechenyi';
import SzechenyiEnergia from '../pages/SzechenyiEnergia';

const AppContent = () => {

  let location = useLocation();

  return (

    <main>
      <Switch location={location}>

          <Route exact path={"/"} component={Home} />
          <Route exact path={"/tevekenysegek"} component={Activities} />
          <Route exact path={"/rolunk"} component={About} />
          <Route exact path={"/kapcsolat"} component={Contact} />
          <Route exact path={"/kozerdeku"} component={Public} />  
          <Route exact path={"/szechenyi"} component={Szechenyi} />  
          <Route exact path={"/szechenyi/energia"} component={SzechenyiEnergia} />  

      </Switch>
    </main>  

  );
};

export default AppContent;